import { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { logoutService } from 'shared/services';
import { handleAccessToken } from 'shared/slice/userSlice';

const INACTIVITY_TIMEOUT_MS = 15 * 60 * 1000;

export const useAutoLogout = (accessToken) => {
  const dispatch = useDispatch();
  const timerRef = useRef(null);

  const clearLogoutTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const startLogoutTimer = useCallback(() => {
    clearLogoutTimer();
    timerRef.current = setTimeout(() => {
      logoutService().then(() => {
        localStorage.removeItem('access_token');
        dispatch(handleAccessToken(null));
      });
    }, INACTIVITY_TIMEOUT_MS);
  }, [clearLogoutTimer, dispatch]);

  useEffect(() => {
    if (!accessToken) {
      clearLogoutTimer();
      return undefined;
    }

    startLogoutTimer();
    window.addEventListener('mousemove', startLogoutTimer);
    window.addEventListener('keydown', startLogoutTimer);

    return () => {
      clearLogoutTimer();
      window.removeEventListener('mousemove', startLogoutTimer);
      window.removeEventListener('keydown', startLogoutTimer);
    };
  }, [accessToken, clearLogoutTimer, startLogoutTimer]);
};
